import useDetectPrint from 'conversations/evaluation-submission/hooks/useDetectPrint';
import { PropsWithChildren } from 'react';
import { Box, Flex } from 'reflexbox';

export default function LayoutSection({ children }: PropsWithChildren) {
	const isPrinting = useDetectPrint();
	return (
		<Flex justifyContent={['left', 'center']} flexDirection="row" flexWrap="wrap-reverse">
			<Box px={[16, 0, 0]} width={isPrinting ? 1 : ['auto', 10 / 12]} maxWidth={1000}>
				{children}
			</Box>
		</Flex>
	);
}
